import { KitProvider } from 'creative-ui/contexts/KitContext';
import { lazy, Suspense } from 'react';

import { LoadingCard } from '@/components/Loading/LoadingCard';
import { useGtmScript } from '@/hooks/useGtmScript';
import { useNalloChatWidget } from '@/hooks/useNalloChatWidget';
import { tagging } from '@/lib/tagging';
import 'creative-ui/oktaComponents/styles/OktaStyle';
import '@/styles/core.css';
import '@/styles/overrides.css';

import { TaggingContext } from '@/lib/tagging/TaggingContext';

import OktaScreenShell from './components/OktaScreenShell/OktaScreenShell';

/**
 * Main App Component
 * Conditionally loads DevScreenManager or ProdScreenManager based on environment
 * Uses React.lazy() for optimal code splitting and tree-shaking
 */

// Conditionally lazy-load the appropriate screen manager
const ScreenManager = lazy(() => {
  if (import.meta.env.DEV) {
    return import('./DevScreenManager');
  } else {
    return import('./ProdScreenManager');
  }
});

export default function App() {
  useNalloChatWidget();
  useGtmScript();
  return (
    <TaggingContext value={tagging}>
      <KitProvider>
        <OktaScreenShell>
          <Suspense fallback={<LoadingCard />}>
            <ScreenManager />
          </Suspense>
        </OktaScreenShell>
      </KitProvider>
    </TaggingContext>
  );
}
